import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import SectionHeader from '../components/SectionHeader';
import ServiceCard from '../components/ServiceCard';
import ToolStackMatrix from '../components/ToolStackMatrix';
import { ENGAGEMENT_MODELS, SEGMENTS, SERVICE_CARDS } from '../data/services';
import { usePageMeta } from '../hooks/usePageMeta';

function Services() {
  usePageMeta({
    title: 'Services | EightyThreeLabs',
    description:
      'Three services: Copilot & Power Platform, Automation Workflows, and Microsoft 365 Setup — for small and mid-sized organizations that want automation that actually runs.',
  });

  return (
    <Layout>
      <PageHeader
        eyebrow="OUR SERVICES"
        title="End-to-End AI Transformation"
        description="Three services, one team. Scoping, readiness, and adoption are part of every engagement — not separate line items."
      />

      <section className="section section-white">
        <div className="container">
          <div className="services-grid reveal">
            {SERVICE_CARDS.map(service => (
              <ServiceCard key={service.title} service={service} />
            ))}
          </div>
        </div>
      </section>

      <section className="section section-gray">
        <div className="container">
          <SectionHeader eyebrow="WHO WE SERVE" title="Built for Your Size and Stage" />
          <div className="segment-grid reveal">
            {SEGMENTS.map(segment => (
              <div className="segment-card" key={segment.label}>
                <span className="segment-label">{segment.label}</span>
                <h3 className="segment-title">{segment.title}</h3>
                <ul className="segment-list">
                  {segment.points.map(point => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-white">
        <div className="container">
          <SectionHeader
            eyebrow="DELIVERY ARCHITECTURE"
            title="Built to Turn AI Into Action"
            subtitle="Every engagement is designed as one connected system, linking data, decisions, and delivery so ideas become real business outcomes."
          />
          <div className="reveal">
            <ToolStackMatrix />
          </div>
        </div>
      </section>

      <section className="section section-gray">
        <div className="container">
          <SectionHeader eyebrow="ENGAGEMENT MODELS" title="How We Work Together" />
          <div className="services-grid reveal">
            {ENGAGEMENT_MODELS.map(model => (
              <div className="service-card" key={model.title}>
                <h3 className="service-title">{model.title}</h3>
                <p className="service-description">{model.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default Services;
